import React from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import './About.css';
import Updated from "../Messages/Updated";
import FeedbackDataService from "../../services/feedback.service";

class Feedback extends React.Component{

  constructor(props) {
    const isLoggedIn = window.localStorage.getItem("userid") ? true : false;
    let userid = 0;
    if(isLoggedIn)
    {
    userid = window.localStorage.getItem("userid");

    }
  
    super(props);
    this.state = {
      feedback: '',
      userid: userid,
      category: 0,
      stage : 0
    };
  }

 
  completeFeedback() {

    this.setState({stage: 0});
    var data = {
      feedback: this.state.feedback,
      category: this.state.category,
      userid: this.state.userid
    };

    FeedbackDataService.createFeedback(data)
    .then(response => {
      if(response.data !== '')
      {

        this.setState({stage: 1});
        this.setState({ feedback: ''});
        this.setState({ category : 0});
      }
      else
      {

        this.setState({stage: 2});
      }


    })
    .catch(e => {
      console.log(e);
    });

  }


  componentDidMount() {

    

   
  }

  onChangeValuefeedback = (event) => {
   
    this.setState({feedback: event.target.value})
  }


  validateForm = () => {
    return this.state.feedback !==  '' && this.state.category !== 0 ;
  }

  handleSubmit = async (event) => {
    event.preventDefault();
    if(parseInt(this.state.userid) === 0)
    {
      return;
    }
    this.completeFeedback();


  }

  onCategoryChange= (event) => {
  
    this.setState({category: event.target.value})
  }

render(){
return (
  <div>
     <Form onSubmit={this.handleSubmit}>

  <div  className="row background-questions">
  <div className="col-md-12 front-text font-text-color">
  {this.state.stage === 1 ? <Updated Message={'Feedback added.'}/> : ''}
  {this.state.stage === 2 ? <Updated Message={'Unable to add Feedback.'}/> : ''}
  </div>
     <div className="col-md-12 front-text feedback">
    <span>Help us improve our platform by providing your feedback</span>
    </div>

    <Form.Group  size="lg" className="category-box col-md-5" controlId="category">
          <Form.Label>Category</Form.Label>
          <Form.Control as="select" value={this.state.category} onChange={this.onCategoryChange.bind(this)}>
          <option value="0"></option>
           <option value="1">Suggestions</option>
           <option value="2">Testimonials</option>
           <option value="3">Comments</option>
           <option value="4">Helpdesk</option>
           <option value="5">Bugs</option>
    </Form.Control>
        </Form.Group>
        <Form.Group size="lg" controlId="feedback" className="col-md-12">
      <div  className="col-md-11 input-size">
      <Form.Label>Comments</Form.Label>
        <br/>
        <Form.Control as="textarea"  value={this.state.feedback} placeholder="250 characters only" maxLength="250" className="title" name="feedback" cols="50" rows="6" onChange={this.onChangeValuefeedback} >

        </Form.Control>
      </div>
      </Form.Group>

  {

      this.state.feedback !==  '' && this.state.category !== 0?
    
       <div className="row col-sm-12">
       <div className="col-sm-2 offset-6">
      
            <button type="submit" disabled={!this.validateForm()}><img width="75" src="save.png" alt="save" /></button>
            <Link  to="/home"><img width="75" src="home.png" alt="save" /></Link>
            </div> 
            <div className="col-sm-2">
    
           
            </div>
        </div>



    : ''
}
  </div>
  </Form>
  </div>

);
}

}

export default Feedback;